/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/useQaStandardChecks.ts
 * FILE_ID: JOBHUB-QA-STANDARD-CHECKS-HOOK-001
 * PURPOSE: Load the standard-check catalog and add one set to the open checklist.
 */
import { useQuery } from '@tanstack/react-query'
import type { QaAreaExecution } from '../../qa/qaApi'
import type { JobQaTabController } from './useJobQaTabController'

export function useQaStandardChecks(controller: JobQaTabController) {
  const api = controller.api
  const catalog = useQuery({
    queryKey: ['qa-standard-checks'],
    queryFn: () => api.listStandardChecks(),
    staleTime: Infinity,
  })
  const targetId = () => {
    const execution = controller.workspace.areaExecQuery?.data as QaAreaExecution | undefined
    const lists = execution?.checklists ?? []
    const active = controller.workspace.activeChecklistId
    if (active && lists.some((list) => list.id === active)) return active
    if (lists.length === 1) return lists[0]?.id ?? null
    return null
  }
  const add = async (key: string) => {
    const checklistId = targetId()
    if (!checklistId) return { created: [], skipped: 0 }
    const result = await api.addStandardChecks(checklistId, key)
    controller.workspace.invalidateExecution()
    if (result.created.length === 0) controller.setError('Already in this checklist')
    return result
  }
  return {
    sets: catalog.data ?? [],
    loading: catalog.isLoading,
    failed: catalog.isError,
    targetId,
    add,
  }
}
